import { Card, HoverCard, Text } from "@mantine/core"
import { useSuspenseQueryGet } from "../../typed-client/hooks/use-suspense-query-get"
import { SuspenseWithErrorBoundary } from "../../-components/suspense"
import { SimplePerson } from "../../@client/Theasoft_ApiServer_Persons"

function PersonDropdown({ personId }: { personId: number }) {
  const person = useSuspenseQueryGet("/api/Person/GetSimplePersonWithUsers", {
    personId,
  })

  return (
    <Card>
      <Card.Section>
        <Text c="gray" size="xs">
          {person.data.personId}
        </Text>
        <Text size="sm">{person.data.name}</Text>
        <div>
          {person.data.users.length === 0 ? (
            <Text c="gray">Diese Person hat keinen Benutzer</Text>
          ) : null}
          {person.data.users.map((user, i) => (
            <Text key={i} size="sm" c="blue">
              Benutzer {user.userName} ({user.userId})
            </Text>
          ))}
        </div>
      </Card.Section>
    </Card>
  )
}

export function PersonPopover2({
  personId,
  children,
}: {
  personId: number
  children: (data: SimplePerson) => React.ReactNode
}) {
  const person = useSuspenseQueryGet(
    "/api/Person/GetSimplePerson",
    { personId },
    { staleTime: 10000 }
  )
  return (
    <HoverCard shadow="md" openDelay={500}>
      <HoverCard.Target>{children(person.data)}</HoverCard.Target>
      <HoverCard.Dropdown>
        <SuspenseWithErrorBoundary>
          <PersonDropdown personId={personId} />
        </SuspenseWithErrorBoundary>
      </HoverCard.Dropdown>
    </HoverCard>
  )
}

export function PersonPopover({
  personId,
  children,
}: {
  personId: number
  children: React.ReactNode
}) {
  return (
    <HoverCard shadow="md" openDelay={500}>
      <HoverCard.Target>
        {typeof children === "string" ? <Text span>{children}</Text> : children}
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <SuspenseWithErrorBoundary>
          <PersonDropdown personId={personId} />
        </SuspenseWithErrorBoundary>
      </HoverCard.Dropdown>
    </HoverCard>
  )
}
